import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router'

import { Header } from '@ulule/header'
import * as layout from '@owl-nest/layout'
import * as plume from '@ulule/owl-kit-components/next'
import type * as env from '@owl-nest/config'

type UserConfig = Awaited<ReturnType<typeof env.getUserConfig>>

/**
 * Mount the reused ulule.com site chrome (Header + Footer) into their standalone-page roots
 * (`#react-ulule-header` / `#react-ulule-footer`), client-only — shared by every static About page
 * (called from each page's entry-client after `bootstrap()`).
 */
export function mountHeaderAndFooter(userConfig: UserConfig): void {
  const headerContainer = document.getElementById('react-ulule-header')
  if (headerContainer !== null) {
    // White bottom-border header, exactly as the homepage configures it.
    // Router is a dependency of the header's partnership tracking.
    ReactDOM.createRoot(headerContainer).render(
      <Router>
        <Header lang={userConfig.lang} theme={{ colors: { primary: plume.COLORS.PRIMARY_GREY_000 } }} />
      </Router>,
    )
  }

  const footerContainer = document.getElementById('react-ulule-footer')
  if (footerContainer !== null) {
    // TODO(footer): dark ("contrast") variant is a follow-up — it needs the layout sub-components
    // (Body/Toes/Manifesto) themed to var(--plume-footer-*). Light footer is reused as-is for v1.
    ReactDOM.createRoot(footerContainer).render(
      <layout.Footer lang={userConfig.lang} navSections={layout.getNavSectionList(userConfig.lang)} />,
    )
  }
}
